import LayoutCreator from '../components/layout-creator'

function LayoutCreatorPage() {
  return <LayoutCreator />
}

export default LayoutCreatorPage
